import Icon from "@ant-design/icons";
import { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const VerticalSVG = () => (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M12.2917 5.5833C13.5573 5.5833 14.5833 4.5573 14.5833 3.29165C14.5833 2.02601 13.5573 1 12.2917 1C11.026 1 10 2.02601 10 3.29165C10 4.5573 11.026 5.5833 12.2917 5.5833Z" fill="current" stroke="current"/>
  <path d="M12.2917 14.2916C13.5573 14.2916 14.5833 13.2656 14.5833 12C14.5833 10.7343 13.5573 9.70833 12.2917 9.70833C11.026 9.70833 10 10.7343 10 12C10 13.2656 11.026 14.2916 12.2917 14.2916Z" fill="current" stroke="current"/>
  <path d="M12.2917 23C13.5573 23 14.5833 21.974 14.5833 20.7083C14.5833 19.4427 13.5573 18.4167 12.2917 18.4167C11.026 18.4167 10 19.4427 10 20.7083C10 21.974 11.026 23 12.2917 23Z" fill="current" stroke="current"/>
</svg>);

export const VerticalIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={VerticalSVG} {...props} />
);
